<!-- 开播-->
<template>

  <div class="joinbox">
    <Header :istab='true' :iskaibo='iskb'></Header>

    <!--未开播部分 -->

    <!--开播部分 -->
    <div style=" height:80% " class="kbbox">
      <div class="left">

        <div class="userinfo">
          <img class="head" :src="userlist.head" alt="">
          <div class="riinfo">
            <p class="name">{{ userlist.name }}</p>
            <div class="imgss">
              <img :src="'https://resource.imbeiyu.com/20210926/gender/icon_gender' + userlist.gender + '.png'" alt="">
              <img :src="`https://resource.imbeiyu.com/2021_09_24/level_${userlist.level}.png`" alt="">
            </div>
            <p class="ID">ID：{{ userlist.uid }}</p>
          </div>
        </div>

        <div class="listbox">
          <div class="tabs">
            <p @click="listtab(1)" :class="list_tabnum == 1 ? 'active' : ''">观众</p>
            <p @click="listtab(2)" :class="list_tabnum == 2 ? 'active' : ''">日榜</p>
            <p @click="listtab(3)" :class="list_tabnum == 3 ? 'active' : ''">周榜</p>
            <p @click="listtab(4)" :class="list_tabnum == 4 ? 'active' : ''">总榜</p>
          </div>
          <div v-if="list_tabnum == 1" class="gzlist">
            <p class="nums">{{ audiencenum > 0 ? audiencenum : 0 }}人</p>
            <el-scrollbar wrap-class="scrollbar-wrapper" style="height:80%;">
              <ul v-infinite-scroll="moredata" class="liebi infinite-list">
                <li v-for="(item, index) in audiencelist" :key="index">
                  <img class="head" :src="item.head" alt="">
                  <div class="riinfo">
                    <p class="name">{{ item.name }}</p>
                    <div class="imgss">
                      <img :src="'https://resource.imbeiyu.com/20210926/gender/icon_gender' + item.gender + '.png'"
                        alt="">
                      <img :src="`https://resource.imbeiyu.com/2021_09_24/level_${item.level}.png`" alt="">
                    </div>
                    <!-- <p class="ID">ID：{{userlist.uid}}</p>   -->
                  </div>
                </li>
              </ul>
              <img v-if="audiencelist.length == 0" class="nodata"
                src="https://resource.imbeiyu.com/gw/assets/images/web/pic_default_none.png" alt="">
            </el-scrollbar>
          </div>
          <!--榜单列表  -->
          <div v-else class="sylist">
            <p class="nums">{{ totalIncome }}魅力</p>
            <el-scrollbar wrap-class="scrollbar-wrapper" style="height:80%;">
              <div class="top3box">

                <div class="headbox">
                  <div v-for="(item, index) in ranklist" v-if="index < 3" :key="index"
                    :class="`topbg  top${index + 1}bg`">
                    <div class="headbox">
                      <i class="headbg"></i>
                      <img class="head" :src="item.head | replace" alt="">
                    </div>

                    <div class="topuser ">
                      <p class="name">{{ item.name }}</p>
                      <div class="imgs"><img :src="`https://resource.imbeiyu.com/2021_09_24/level_${item.level}.png`"
                          alt=""> </div>
                      <p class="num">贡献 <i class="ybnum"> {{ item.value }}</i> </p>
                    </div>
                  </div>


                </div>

              </div>
              <ul v-if="ranklist && ranklist.length > 3" v-infinite-scroll="moredata"
                class="liebi bdlieb infinite-list">
                <li v-for="(item, index) in ranklist" v-if="index > 2" :key="index">
                  <i class="rank">{{ index + 1 }}</i>
                  <img class="head" :src="item.head | replace" alt="">
                  <div class="riinfo">
                    <p class="name">{{ item.name }}</p>
                    <div class="imgss">
                      <img :src="'https://resource.imbeiyu.com/20210926/gender/icon_gender' + item.gender + '.png'"
                        alt="">
                      <img :src="`https://resource.imbeiyu.com/2021_09_24/level_${item.level}.png`" alt="">
                    </div>
                  </div>
                  <p class="gxnum">贡献 <i class="ybnum"> {{ item.value }}</i> </p>
                </li>
              </ul>

              <img v-if="ranklist.length == 0" class="nodata"
                src="https://resource.imbeiyu.com/gw/assets/images/web/pic_default_none.png" alt="">
            </el-scrollbar>
          </div>

        </div>

      </div>

      <div class="live-center" ref="livecenter">

        <div v-if="!iskb" class="getkbo">
          <div class="select">
            <span class="labe">摄像头:</span>
            <el-select popper-class='livekb' @change="changeVideodevice()" v-model="videoid" placeholder="请选择">
              <el-option v-for="item in videoinputs" :key="item.deviceId" :label="item.label" :value="item.deviceId">
              </el-option>
            </el-select>
            <el-tooltip class="item" effect="dark" placement="right-start" popper-class='tooltiptxt'>

              <div slot="content">选择设备前，请先打开开播助手
                <br>(1)调试助手的开播画面 (分辨率推荐1280*720)
                <br>(2)调节助手中的美颜、滤镜；
                <br>(3)开播页面里，摄像头选择开播助手；
                <br>*已开启助手，找不到？
                <br>方法：刷新页面再选择设备
                <br>*提示：设备被占用、重新检查开播设备？
                <br>方法：退出所有开播助手，只开启其中一个并刷新页面重新选择
              </div>
              <el-button class="queicon "></el-button>
            </el-tooltip>
          </div>
          <div class="select">
            <span class="labe">声卡:</span>
            <el-select popper-class='livekb' @change="changeAudiodevice()" v-model="audioid" placeholder="请选择">
              <el-option v-for="item in audioinputs" :key="item.deviceId" :label="item.label" :value="item.deviceId">
              </el-option>
            </el-select>
            <el-tooltip class="item" effect="dark" placement="right-start" popper-class='tooltiptxt'>

              <div slot="content">
                *声卡选项为空？
                <br>方法：刷新页面，弹出麦克风权限，设置为允许访问再重新选择设备
                <br>*刷新后选择框仍为空？
                <br>方法：直接点击开始开播，开播成功后关播，
                <br>刷新后再重试，选择框随即出现设备选项
              </div>
              <el-button class="queicon "></el-button>
            </el-tooltip>
          </div>
          <div class="select">
            <span class="labe">屏幕比例:</span>
            <el-select popper-class='livekb' @change="changelivesize()" v-model="livesizeid" placeholder="请选择">
              <el-option v-for="item in livesize" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class=" kbfm">
            <span class="labe">开播封面:</span> <img :src="prepareinfo.authInfos.cover | replace" alt="">
          </div>
          <div class="kbtitle">
            <span class="labe">开播标题:</span>
            <div class="input">
              <input v-model="Commonname" type="text"> <i @click="livetitle()" ref="changeBtn" class="changeBtn"></i>
            </div>
          </div>

          <button @click="getstart()" class="starlive">开始直播</button>
          <p class="kbtxt">开播默认同意遵守<a target="暖暖星球主播协议"
              href="https://web.imbeiyu.com/mobile/helper/anchorProtocol_ios.html">《暖暖星球主播协议》</a></p>



        </div>

        <div v-else class="videbox">
          <div class="col">
            <div id="local-player" :style="sliderStyle" class="player">
              <button v-loading.fullscreen.lock="fullscreenLoading" @click="closebtn()" class="closebtn"><i></i>关播
              </button>
            </div>

          </div>

        </div>

      </div>



      <!-- 消息 -->
      <div class="right">

        <div class="tabs">
          <p @click="infotab(1, 'allscroll')" :class="info_tabnum == 1 ? 'active' : ''">综合</p>
          <p @click="infotab(2, 'ltscroll')" :class="info_tabnum == 2 ? 'active' : ''">聊天</p>
          <p @click="infotab(3, 'songliscroll')" :class="info_tabnum == 3 ? 'active' : ''">送礼</p>
          <p @click="infotab(4, 'xtscroll')" :class="info_tabnum == 4 ? 'active' : ''">公告</p>
        </div>
        <div v-if="info_tabnum == 1" class="allinfo">
          <el-scrollbar ref="allscroll" style="height:93%;">

            <ul>
              <li class="tsTxt">温馨提示：我们提倡健康的直播环境，严禁谩骂、色情低俗、政治敏感话题、未成年直播等违规内容。
                同时请大家注意财产安全，谨防网络诈骗。搜索关注微信公众号【暖暖星球live】获取更多优惠！ </li>

              <li v-for="(item, index) in alllist" :key="index">

                <div v-if="item.listtype == 3" class="li xitonginfoli">
                  {{ item.txt }}
                </div>

                <div v-else-if="item.listtype == 1" class="li songliinfoli">

                  <img class="level" :src="`https://resource.imbeiyu.com/2021_09_24/level_${item.level}.png`" alt="">

                  <img v-if="item.vip != -1"
                    :src="'https://resource.imbeiyu.com/2021_09_24/tag_vip' + item.vip + '_14.png'" alt="">
                  <span class="name">{{ item.fromName }} </span> 送给 <span class="name"> {{ item.toName }}</span>
                  <span class="gift"> {{ item.giftname }} {{ item.rewardname ? '' : '(' + item.price + '钻)' }}</span>
                  <img class="gifimg" :src="item.gifturl" alt="">
                  <span class="giftnum"> X {{ item.giftNum }}</span>
                  <span v-if="item.rewardname" class="gift">开出</span>
                  <span v-if="item.rewardname" class="giftnum">{{ item.rewardname }} {{ '(' + item.price + '钻)'
                  }}</span>
                  <img v-if="item.rewardname" class="gifimg" :src="item.rewardurl" alt="">
                </div>

                <div v-else-if="item.listtype == 2" class="li ltinfoli">
                  <img v-if="item.type == 41"
                    src="https://resource.imbeiyu.com/gw/assets/images/web/tag_quanzhan_14.png" alt="">
                  <img class="level" :src="`https://resource.imbeiyu.com/2021_09_24/level_${item.level}.png`" alt="">
                  <img v-if="item.vip != -1"
                    :src="'https://resource.imbeiyu.com/2021_09_24/tag_vip' + item.vip + '_14.png'" alt="">
                  <span class="name">{{ item.name }}：</span> <span :style="{ color: item.color ? item.color : '' }">{{
                      item.txt
                  }}</span>
                </div>


              </li>

            </ul>
            <img v-if="alllist.length == 0" class="nodata"
              src="https://resource.imbeiyu.com/gw/assets/images/web/pic_default_message.png" alt="">


          </el-scrollbar>
          <div class="inputs">
            <input @keyup.enter="getPubmsg()" v-model="fyvale" placeholder="大家一起聊聊天吧">
            <button @click="getPubmsg()">发送</button>
          </div>

        </div>
        <div v-else-if="info_tabnum == 4" class="xitonginfo">
          <!-- <p class="title_t">系统消息</p> -->
          <el-scrollbar ref="xtscroll" style="height:93%;">

            <ul>
              <li v-for="(item, index) in xtlist" :key="index">
                <div class="li">
                  {{ item.txt }}
                </div>

              </li>

            </ul>
            <img v-if="xtlist.length == 0" class="nodata"
              src="https://resource.imbeiyu.com/gw/assets/images/web/pic_default_message.png" alt="">


          </el-scrollbar>
        </div>
        <div v-else-if="info_tabnum == 3" class="songliinfo">
          <!-- <p class="title_t">送礼</p> -->
          <el-scrollbar ref="songliscroll" style="height:93%;">
            <ul>
              <li v-for="(item, index) in sllist" :key="index">
                <div class="li">

                  <img class="level" :src="`https://resource.imbeiyu.com/2021_09_24/level_${item.level}.png`" alt="">

                  <img v-if="item.vip != -1"
                    :src="'https://resource.imbeiyu.com/2021_09_24/tag_vip' + item.vip + '_14.png'" alt="">
                  <span class="name">{{ item.fromName }} </span> 送给 <span class="name"> {{ item.toName }}</span>
                  <span class="gift"> {{ item.giftname }} {{ item.rewardname ? '' : '(' + item.price + '钻)' }}</span>
                  <img class="gifimg" :src="item.gifturl" alt="">
                  <span class="giftnum"> X {{ item.giftNum }}</span>
                  <span v-if="item.rewardname" class="gift">开出</span>
                  <span v-if="item.rewardname" class="giftnum">{{ item.rewardname }} {{ '(' + item.price + '钻)'
                  }}</span>
                  <img v-if="item.rewardname" class="gifimg" :src="item.rewardurl" alt="">
                </div>
              </li>

            </ul>
            <img v-if="sllist.length == 0" class="nodata"
              src="https://resource.imbeiyu.com/gw/assets/images/web/pic_default_nothing.png" alt="">
          </el-scrollbar>
        </div>
        <div v-else-if="info_tabnum == 2" class="ltinfo">
          <!-- <p class="title_t">聊天</p> -->
          <el-scrollbar ref="ltscroll" style="height:93%;">

            <ul>
              <li v-for="(item, index) in ltlist" :key="index">
                <div class="li">
                  <img v-if="item.type == 41"
                    src="https://resource.imbeiyu.com/gw/assets/images/web/tag_quanzhan_14.png" alt="">
                  <img class="level" :src="`https://resource.imbeiyu.com/2021_09_24/level_${item.level}.png`" alt="">
                  <img v-if="item.vip != -1"
                    :src="'https://resource.imbeiyu.com/2021_09_24/tag_vip' + item.vip + '_14.png'" alt="">
                  <span class="name">{{ item.name }}：</span> <span :style="{ color: item.color ? item.color : '' }">{{
                      item.txt
                  }}</span>
                </div>
              </li>


            </ul>
            <img v-if="ltlist.length == 0" class="nodata"
              src="https://resource.imbeiyu.com/gw/assets/images/web/pic_default_message.png" alt="">
          </el-scrollbar>
          <div class="inputs">
            <input @keyup.enter="getPubmsg()" v-model="fyvale" placeholder="大家一起聊聊天吧">
            <button @click="getPubmsg()">发送</button>
          </div>
        </div>

      </div>

    </div>





  </div>
</template>


<script>

import Header from "../../components/header"
import mqtt from 'mqtt'
// import SVGA from "svgaplayerweb"
import AgoraRTC from "agora-rtc-sdk-ng"
// import Pclogin  from "../../components/pclogin"
// import VueAliplayer from 'vue-aliplayer'

var client

export default {
  components: {
    Header
  },

  data() {

    return {
      addgift: null, // 是否添加礼物特效
      gittype: '',//礼物特效类型
      gifurl: '',// 礼物特效地址
      giftarr: [],
      fyvale: '',
      input: '',
      list_tabnum: 1,
      info_tabnum: 1,
      Commonname: '',

      livesizeid: 1,
      livesize: [{
        value: 1,
        label: '16:9'
      }, {
        value: 2,
        label: '4:3'
      },],

      videoid: '',
      videoinputs: [],
      audioid: '',
      audioinputs: [],
      sliderStyle: {
        width: "4.64rem", height: '2.61rem'
      },
      client: null,
      localTracks: {
        videoTrack: null,
        audioTrack: null
      },
      iskb: false,
      fullscreenLoading: false,
      islogin: false,
      msg: '',
      prepareinfo: {
        userCommon: {},
        authInfos: {},
      },
      remoteUsers: {},
      liveinfo: {},
      userlist: {},
      ImInfo: {},
      xtlist: [], // 系统消息
      sllist: [], // 送礼消息
      ltlist: [], // 聊天消息
      alllist: [], // 综合消息
      listtabIn: null,
      audiencelist: [],
      audiencenum: 0,
      audiencepage: 0,

      dd: .29,
      playerId: "aliplayer_" + Math.random().toString(36).substr(2),
      instance: null, //播放器实例
      endTime: 0,//
      playauth: true,
      vid: 0,
      _gap_time: '',
      _beforeUnload_time: '',
      loopId: null,
      ranklist: [], //榜单
      totalIncome: null, //榜单
    }

  },
  created() {


    if (localStorage.getItem("userinfo")) {
      this.userlist = JSON.parse(localStorage.getItem("userinfo"));
      this.islogin = true

      if (sessionStorage.getItem("liveinfo")) {
        sessionStorage.removeItem("liveinfo")
        sessionStorage.removeItem("ImInfo")
      }

      this.getDevices()
      this.getprepare()


    } else {
      this.islogin = false
      this.$message.error('您的用户信息已过期，请重新登录！');
      this.$router.push({ path: '/pchome' })
    }




    window.addEventListener("unload", e => this.unloadFn());
    window.addEventListener("beforeunload", e => this.beforeunloadFn(e));





  },
  beforeDestroy() {

  },
  destroyed() {
    window.removeEventListener("unload", e => this.unloadFn());
    window.removeEventListener("beforeunload", e => this.beforeunloadFn());




  },
  watch: {
  },

  mounted() {




    window.addEventListener('setItem', function (e) {
      location.reload()
    })
  },
  methods: {
    async getDevices() {
      // 获取所有音视频设备。
      this.client = AgoraRTC.createClient({ mode: "live", codec: "h264" });
      const devices = await AgoraRTC.getDevices();
      console.log("this.videoinputs")

      this.audioinputs = devices.filter(function (device) {
        return device.kind === 'audioinput';
      });
      this.videoinputs = devices.filter(function (device) {
        return device.kind === 'videoinput';
      });
      console.log(devices)
    },

    async liveTranscoding() {
      var _this = this

      if (_this.videoid == '') {
        this.$message.error('请选择摄像头');
        return
      } else if (_this.audioid == '') {
        this.$message.error('请选择声卡');
        return
      }
      _this.fullscreenLoading = true
      _this.iskb = true
      console.log('djdo', _this.liveinfo.agoraInfo)
      var options = {
        appid: _this.liveinfo.agoraInfo.appId,
        channel: _this.liveinfo.agoraInfo.channel,
        uid: Number(_this.userlist.uid),
        token: _this.liveinfo.agoraInfo.token,
        liveStreamingUrl: _this.liveinfo.pushUrl,
        role: "host" // host or audience
      };
      _this.client.setClientRole(options.role);
      options.uid = await _this.client.join(options.appid, options.channel, options.token || null, options.uid || null);
      var w, h
      if (_this.livesizeid == 1) { w = 1920; h = 1080 } else if (_this.livesizeid == 2) { w = 1280; h = 960 }

      if (options.role === "host") {
        // create local audio and video tracks
        _this.localTracks.audioTrack = await AgoraRTC.createMicrophoneAudioTrack(
          {
            encoderConfig: 'high_quality_stereo',
            microphoneId: _this.audioid,
          });
        _this.localTracks.videoTrack = await AgoraRTC.createCameraVideoTrack(
          {

            cameraId: _this.videoid,
            mirror: false,
            encoderConfig: {
              width: w,
              height: h,
              frameRate: 30,
              bitrateMin: 3000,
              bitrateMax: 5000,
            },
            optimizationMode: "motion",
          }
        );
        // publish local tracks to channel
        await _this.client.publish(Object.values(_this.localTracks));

        console.log("publish success");
        // play local video track


        if (_this.livesizeid == 1) { _this.sliderStyle.height = '2.61rem' }
        else if (_this.livesizeid == 2) { _this.sliderStyle.height = '3.48rem' }

        _this.localTracks.videoTrack.play("local-player", { fit: 'cover', mirror: false });
        setTimeout(() => {
          _this.fullscreenLoading = false
          _this.livestreaming()

        }, 500)

        _this.listtabIn = setInterval(() => {
          _this.listtab(_this.list_tabnum)
        }, 10000);

      }
    },
    async changelivesize() {

      if (this.localTracks.audioTrack) {
        this.localTracks.audioTrack.close();
      }
      if (this.localTracks.videoTrack) {
        this.localTracks.videoTrack.close();
      }
      this.videoid = ''
      this.audioid = ''
    },
    async changeAudiodevice() {
      try {
        this.localTracks.audioTrack = await AgoraRTC.createMicrophoneAudioTrack(
          {
            microphoneId: this.audioid,
          });
      } catch (error) {
        this.$message.error('麦克风设备被占用，请重新选择开播设备');
      }

    },
    async changeVideodevice() {
      var w, h
      if (this.livesizeid == 1) { w = 1920; h = 1080 } else if (this.livesizeid == 2) { w = 800; h = 600 }
      try {
        this.localTracks.videoTrack = await AgoraRTC.createCameraVideoTrack(
          {
            cameraId: this.videoid,
            encoderConfig: {
              width: w,
              height: h,
              frameRate: 30,
              bitrateMin: 3000,
              bitrateMax: 5000,
            },
          }
        );
      } catch (error) {
        console.log(error)
        this.$message.error('摄像头设备被占用，请重新选择开播设备！');
      }



    },
    async livestreaming() {
      var _this = this
      //  configuration of pushing stream to cdn

      const liveTranscodingConfig = { // pk会用到的配置
        width: 1280,
        height: 720,
        videoBitrate: 1130, //直播推流的输出视频的码率
        videoFramerate: 24, //直播推流的输出视频的帧率
        lowLatency: false,
        audioSampleRate: AgoraRTC.AUDIO_SAMPLE_RATE_48000,
        audioBitrate: 48, //直播推流的输出音频的码率
        audioChannels: 1,
        videoGop: 30, //直播推流的输出视频的 GOP
        videoCodecProfile: AgoraRTC.VIDEO_CODEC_PROFILE_HIGH,
        userCount: 1,
        backgroundColor: 0x000000,

        transcodingUsers: [
          {
            uid: 111,
            alpha: 1,
            width: 1,
            height: 1,
            zOrder: 1,
            x: 0,
            y: 0,
          },
        ],
      }

      try {


        // set live streaming transcode configuration,
        // await _this.client.setLiveTranscoding(liveTranscodingConfig);
        // then start live streaming.
        await _this.client.startLiveStreaming(_this.liveinfo.pushUrl, false);
      } catch (error) {
        console.error('live streaming error:', error.message)
      }

    },

    mqttMSG() {
      // mqtt连接

      var topic1 = 'nuannuan/server/broadcast/room/' + this.liveinfo.lid + '/0'
      var topic2 = 'nuannuan/server/broadcast/room/' + this.liveinfo.lid + '/2'
      var topic3 = 'nuannuan/server/unicast/room/' + this.liveinfo.lid + '/' + this.userlist.uid + '/0'
      //  var topic4 = 'nuannuan/server/broadcast/room/' + this.liveinfo.lid + '/10'

      client.on('connect', (e) => {
        console.log('连接成功:')

        // this.toumingfun()
        // this.SVGA()
        client.subscribe(topic1, (error) => {
          if (!error) { console.log('订阅成功') } else { console.log('订阅失败') }
        });
        client.subscribe(topic3, (error) => {
          if (!error) { console.log('订阅成功') } else { console.log('订阅失败') }
        });
        client.subscribe(topic2, (error) => {
          if (!error) { console.log('订阅成功') } else { console.log('订阅失败') }
        });

      })

      // 接收消息处理
      client.on('message', (topic, message) => {

        // console.log('收到来自', topic, '的消息')

        // this.msg = message.toString()

        //  console.log(message.toString())

        var newpayload = this.Utf8ArrayToStr(message)
        newpayload = this.replaceMqtt(newpayload)

        if (newpayload == undefined) {
          return
        }


        if (newpayload.listtype) { // 综合消息

          if (!newpayload.addgiftNum) {
            this.alllist = this.alllist.concat(newpayload)
            if (this.info_tabnum == 1) {
              this.$nextTick(() => {
                this.scollami('allscroll')
              })
            }
          }

        }


        if (newpayload.listtype == 1) { // 送礼
          console.log(newpayload)
          if (newpayload.addgiftNum) {
            var giftNum = this.sllist[this.sllist.length - 1].giftNum
            this.sllist[this.sllist.length - 1].giftNum = giftNum + newpayload.addgiftNum
            console.log(this.sllist)

          } else {
            this.sllist = this.sllist.concat(newpayload)
            if (this.info_tabnum == 3) {
              this.$nextTick(() => {
                this.scollami('songliscroll')
              })
            }

          }
        } else if (newpayload.listtype == 2) { // 聊天
          this.ltlist = this.ltlist.concat(newpayload)
          if (this.info_tabnum == 2) {
            this.$nextTick(() => {
              this.scollami('ltscroll')
            })
          }

        } else if (newpayload.listtype == 3) { //系统消息
          this.xtlist = this.xtlist.concat(newpayload)
          if (this.info_tabnum == 4) {
            this.$nextTick(() => {
              this.scollami('xtscroll')
            })
          }
        }


      })
      // 断开发起重连
      client.on('reconnect', (error) => {
        console.log('正在重连:', error)

      })
      // 链接异常处理
      client.on('error', (error) => {
        console.log('连接失败:', error)
      })

    },

    getPubmsg() {                     //判断输入正确后推流
      var that = this
      if (that.fyvale.trim() == '') { return }
      var topic = 'nuannuan/client/broadcast/room/' + that.liveinfo.lid + '/' + that.userlist.uid + '/send'
      if (client && client.connected) {

        var news = {
          "type": 30,
          "body": {
            "roomId": that.liveinfo.lid,
            "uid": that.userlist.uid,
            "body": that.fyvale.trim(),
            "type": 1,
            "name": that.userlist.name,
            "level": that.userlist.level,
            "vip": that.userlist.vip
          }
        }
        news = JSON.stringify(news)
        client.publish(topic, news);
        that.fyvale = ''
      } else {
        that.$message({ message: '请先连接服务器', type: 'warning' });

      }
    },

    playgift() { //播放礼物动画
      return
      if (this.giftarr.length == 0) { return }
      var obj = this.giftarr[0]
      this.gittype = obj.gittype
      this.gifurl = obj.gifurl
      if (this.gittype == 'svga') {
        this.SVGA()
      } else {
        this.toumingfun()
      }
    },
    SVGA() {
      var that = this
      let player = new SVGA.Player("#demoCanvas");
      let parser = new SVGA.Parser("#demoCanvas");
      parser.load(that.gifurl, function (videoItem) { //this.bgImg，图片路径需要线上地址，本地引用会报错
        player.setVideoItem(videoItem);
        player.startAnimation();
        console.log(videoItem)
        var s = videoItem.frames / videoItem.FPS
        setTimeout(() => {

          that.gittype = null
          that.gifurl = ''

          that.giftarr = that.giftarr.slice(0)
          that.giftarr.shift()

          if (that.giftarr.length > 0) { that.playgift() }


        }, s * 1000)
      }
      );
    },


    toumingfun() {

      var that = this
      var outputCanvas = document.getElementById('mp4canvas'),
        output = outputCanvas.getContext('2d'),
        bufferCanvas = document.getElementById('mp4canvas2'),
        buffer = bufferCanvas.getContext('2d'),
        video = document.getElementById('video1'),
        width = outputCanvas.width,
        height = outputCanvas.height,
        interval;
      setTimeout(() => {
        video.play();
      }, 1000)
      //     
      function processFrame() {
        buffer.drawImage(video, 0, 0, 664, height);//drawImage(要绘画的元素, x轴, y轴)
        //getImageData 复制画布上指定图像的像素数据

        var image = buffer.getImageData(332, 0, 664, height),
          imageData = image.data,
          alphaData = buffer.getImageData(332, 0, 664, height).data;
        // console.log(imageData)

        for (var i = 3, len = imageData.length; i < len; i += 4) {
          imageData[i] = alphaData[i - 1];
        }
        // putImageData() 将图像数据放回画布：
        output.putImageData(image, 0, 0, 0, 0, 300, height);
      }

      video.addEventListener('play', function () {
        clearInterval(interval);
        interval = setInterval(processFrame, 40)
      }, false);


      video.addEventListener('ended', function () {
        video.pause();
        that.giftarr = that.giftarr.slice(0)
        that.giftarr.shift()


        that.gittype = null
        that.gifurl = ''
        if (that.giftarr.length > 0) { that.playgift() }

      }, false);
    },

    listHisLiveMsg() {
      var _this = this
      _this.$http.post(_this.$api.listHisLiveMsg,
        {
          uid: _this.userlist.uid,
          loginKey: _this.userlist.loginKey,
          lid: _this.liveinfo.lid,
        }, {
      }
      ).then(function (response) {
        var _data = response.data.list
        _data.forEach(element => {
          var obj = _this.replacebody(element)
          setTimeout(() => {
            _this.ltlist = _this.ltlist.concat(obj)
            _this.alllist = _this.alllist.concat(obj)
          }, 500)
        });


      })
    },
    getIMInfo() {
      var _this = this
      _this.$http.post(_this.$api.getIMInfo, { uid: _this.userlist.uid, loginKey: _this.userlist.loginKey }, {
        headers: {
          uid: _this.userlist.uid,
          loginKey: _this.userlist.loginKey
        }
      }
      ).then(function (response) {
        var _data = response.data.data
        console.log(_data)
        _this.ImInfo = _data
        sessionStorage.setItem("ImInfo", JSON.stringify(_data));
        const options = {
          connectTimeout: 40000,
          clientId: _data.clientId,
          username: _data.userName,
          password: _data.pwd,
          clean: true
        }
        //  _this.ImInfo.imSetting.serverUrl = "wss://test.ayc666.cn/mqtt"
        console.log(_data.imSetting.serverUrl)
        client = mqtt.connect(_this.ImInfo.imSetting.serverUrl, options)
        _this.mqttMSG()
        _this.listHisLiveMsg()
        _this.audiencepage = 1
        // if(_this.list_tabnum ==1){
        //        _this.listAudience(_this.audiencepage)
        //   }else{
        //     _this.listRank(_this.audiencepage)
        //   }
      })
    },
    getprepare() {
      var _this = this
      _this.$http.post(_this.$api.getprepare, {
        uid: _this.userlist.uid,
        loginKey: _this.userlist.loginKey
      }, {
        headers: {
          uid: _this.userlist.uid,
          loginKey: _this.userlist.loginKey
        }
      }
      ).then(function (response) {
        console.log(response);
        if (response.data.state) {
          _this.prepareinfo = response.data
          _this.Commonname = response.data.userCommon.name
          // _this.getstart()

        } else if (response.data.result == 728) {
          _this.$message.error('您的用户信息已过期，请重新登录！');
          _this.$router.push({ path: '/pchome' })
          localStorage.removeItem("userinfo")
        } else if (response.data.msg == '您已经在直播中') {
          // _this.$alert(response.data.msg, '提示', {customClass:'minalert', confirmButtonText: '确定',   });
          _this.liveinfo.lid = response.data.data.lid
          _this.closebtn()
        }




      })
    },
    async closebtn() { // 关闭直播
      var _this = this
      if (_this.localTracks.videoTrack) {

        for (var trackName in _this.localTracks) {
          var track = _this.localTracks[trackName];
          if (track) {
            track.stop();
            track.close();
            _this.localTracks[trackName] = undefined;
          }
        }
        _this.liveinfo.pushUrl && await (_this.client.stopLiveStreaming(_this.liveinfo.pushUrl))
        await _this.client.leave();
        _this.videoid = ''
        _this.audioid = ''
      }
      _this.fullscreenLoading = true
      clearInterval(_this.listtabIn);

      _this.closeUrl()


    },
    closeUrl() {
      var _this = this
      _this.$http.post(_this.$api.livestop, { lid: _this.liveinfo.lid, uid: _this.userlist.uid, loginKey: _this.userlist.loginKey }, {
        headers: {
          uid: _this.userlist.uid, loginKey: _this.userlist.loginKey
        }
      }
      ).then(function (response) {
        console.log(response)
        if (response.data.state) {

          _this.iskb = false
          sessionStorage.removeItem("liveinfo")
          sessionStorage.removeItem("ImInfo")
          // _this.$router.push({path:'/pchome'})
          setTimeout(() => {
            _this.getprepare()
            _this.fullscreenLoading = false
          }, 1000)


        } else {
          _this.fullscreenLoading = false

          that.$message({ message: response.data.msg, type: 'warning' });
        }

      })
    },
    listtab(num) {
      this.list_tabnum = num
      if (num == 1) {
        this.listAudience(1)
      } else {
        this.listRank(1)
      }

    },
    infotab(num, scro) {
      this.info_tabnum = num
      this.$nextTick(() => {
        this.scollami(scro)
      })

    },
    listAudience(num) {  // 观众列表
      var _this = this
      _this.$http.post(_this.$api.listAudience,
        {
          uid: _this.userlist.uid,
          loginKey: _this.userlist.loginKey,
          lid: _this.liveinfo.lid,
          page: num,
          version: 460
        }, {

      }).then(function (response) {
        // console.log(response)
        if (response.data.list && response.data.list.length > 0) {
          if (num == 1) {

            _this.audiencelist = response.data.list
            _this.audiencenum = response.data.audiences
          } else {
            _this.audiencelist = _this.audiencelist.concat(response.data.list)
          }
        }



      })
    },
    listRank(num) {  //贡献列表
      var ranktype
      if (this.list_tabnum == 2) {
        ranktype = 4
      } else if (this.list_tabnum == 3) { ranktype = 5 } else if (this.list_tabnum == 3) { ranktype = 1 }

      var _this = this
      _this.$http.post(_this.$api.listRank,
        {
          uid: _this.userlist.uid,
          loginKey: _this.userlist.loginKey,
          type: ranktype, //类型 1:总榜 4:日榜 5:周榜 6:月榜"
          pageIndex: num,
        }, {

      }).then(function (response) {
        // console.log(response)
        if (response.data.list && response.data.list.length > 0) {
          if (num == 1) {
            _this.ranklist = []
            _this.ranklist = response.data.list
            _this.totalIncome = response.data.totalIncome
          } else {
            _this.ranklist = _this.ranklist.concat(response.data.list)
          }
        }



      })
    },
    moredata() { // 下拉加载观众列表 
      this.audiencepage++
      if (this.list_tabnum == 1) {
        this.listAudience(this.audiencepage)
      } else {
        this.listRank(this.audiencepage)
      }
    },

    livetitle() {
      var _this = this
      _this.$http.post(_this.$api.livetitle, {
        uid: _this.userlist.uid,
        loginKey: _this.userlist.loginKey
      }, {
        headers: {
          uid: _this.userlist.uid,
          loginKey: _this.userlist.loginKey
        }
      }
      ).then(function (response) {
        _this.Commonname = response.data.msg
        _this.$refs.changeBtn.style.transform = 'rotate(90deg)'
        setTimeout(() => {
          _this.$refs.changeBtn.style.transform = 'rotate(0deg)'
        }, 50)


      })
    },

    // 开播获取推流地址
    getstart() {
      var _this = this

      console.log(_this.videoid)

      _this.$http.post(_this.$api.startlive, { title: _this.Commonname, agoraInfo: '声网信息', uid: _this.userlist.uid, loginKey: _this.userlist.loginKey }, {
        headers: {
          uid: _this.userlist.uid,
          loginKey: _this.userlist.loginKey
        }
      }
      ).then(function (response) {
        console.log(response);
        if (response.data.state) {

          _this.liveinfo = response.data
          sessionStorage.setItem("liveinfo", JSON.stringify(response.data));
          _this.liveTranscoding()
          _this.getIMInfo()


        } else {
          _this.$alert(response.data.msg, '提示', { customClass: 'minalert', confirmButtonText: '确定', });



        }


      })
    },


    getCurrentTime: function () {
      return this.instance.getCurrentTime();
    },

    copyUrl2() {
      var _this = this;
      var clipboard = new this.clipboard(".cobyOrderSn2");
      clipboard.on('success', function () {
        _this.$message({ message: '复制成功', type: 'success' });
      });
      clipboard.on('error', function () {
      });
    },

    unloadFn() {
      this._gap_time = new Date().getTime() - this._beforeUnload_time;
      if (this._gap_time <= 5) {
        this.closebtn()
      } else {
        //刷新我需要做的事情
        this.closebtn()
      }
    },
    beforeunloadFn(e) {
      this._beforeUnload_time = new Date().getTime();
      e = e || window.event;

    },

    Utf8ArrayToStr(array) {
      var out, i, len, c;
      var char2, char3;

      out = "";
      len = array.length;
      i = 0;
      while (i < len) {
        c = array[i++];
        switch (c >> 4) {
          case 0: case 1: case 2: case 3: case 4: case 5: case 6: case 7:
            // 0xxxxxxx
            out += String.fromCharCode(c);
            break;
          case 12: case 13:
            // 110x xxxx 10xx xxxx
            char2 = array[i++];
            out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
            break;
          case 14:
            // 1110 xxxx 10xx xxxx 10xx xxxx
            char2 = array[i++];
            char3 = array[i++];
            out += String.fromCharCode(((c & 0x0F) << 12) |
              ((char2 & 0x3F) << 6) |
              ((char3 & 0x3F) << 0));
            break;
        }
      }

      return out;
    },
    //处理mqtt下发消息正则
    replaceMqtt(str) {
      var desc = null;
      var that = this;
      if (str == null) {
        return
      } else {
        // console.log(str)
        desc = str.replace(/\\/g, '').trim();

        var str1 = desc.replace(new RegExp('"{', 'gm'), "{").replace(new RegExp('}"', 'gm'), "}")
        str1 = str1.replace(/<[^>]+>|&[^>]+;/g, "").trim()
        str1 = JSON.parse(str1)
        // console.log(str1)
        var lctext = str1.data.content._lctext.body


        if (lctext.type != 80) {
          console.log(lctext)
        }
        return that.replacebody(lctext)

      }
    },
    replacebody(lctext1) {
      var that = this
      var lctext = lctext1

      var vip = that.changevip(lctext.vip)



      if (lctext.type == 10 || lctext.type == 52) { // 送礼

        if (that.loopId == lctext.body.loopId) { //表示连送
          return {
            addgiftNum: lctext.body.giftNum,
            type: lctext.type,
            listtype: 1,

          }


        } else {
          that.loopId = lctext.body.loopId

          if (lctext.body.reward) { // 有两动画
            var gifobj1, gifobj2;

            if (lctext.body.svgaUrl) {
              gifobj1 = { gittype: 'svga', gifurl: lctext.body.svgaUrl }
              that.giftarr.push(gifobj1)
              that.addgift++
            } else if (lctext.body.videoUrl) {
              gifobj1 = { gittype: 'mp4', gifurl: lctext.body.videoUrl }
              that.giftarr.push(gifobj1)
              that.addgift++
            }
            setTimeout(() => {
              if (lctext.body.reward.svgaUrl) {
                gifobj2 = { gittype: 'svga', gifurl: lctext.body.reward.svgaUrl }
                that.giftarr.push(gifobj2)
                that.addgift++
              } else if (lctext.body.reward.videoUrl) {
                gifobj2 = { gittype: 'mp4', gifurl: lctext.body.reward.videoUrl }
                that.giftarr.push(gifobj2)
                that.addgift++
              }
            }, 300)



            //  console.log(that.giftarr)

            return {
              rewardname: lctext.body.reward.name,
              rewardurl: that.replace(lctext.body.reward.icon),
              giftname: lctext.body.name,
              giftNum: lctext.body.giftNum,
              gifturl: that.replace(lctext.body.icon),
              fromName: lctext.body.fromName,
              toName: lctext.body.toName,
              level: lctext.level,
              price: lctext.body.price,
              type: lctext.type,
              listtype: 1,
              vip: vip,

            }

          } else {
            var gifobj
            if (lctext.body.svgaUrl) {
              gifobj = { gittype: 'svga', gifurl: lctext.body.svgaUrl }
              that.giftarr.push(gifobj)
              that.addgift++
            } else if (lctext.body.videoUrl) {
              gifobj = { gittype: 'mp4', gifurl: lctext.body.videoUrl }
              that.giftarr.push(gifobj)
              that.addgift++
            }
            //  console.log(that.giftarr)
            return {
              giftname: lctext.body.name,
              giftNum: lctext.body.giftNum,
              gifturl: that.replace(lctext.body.icon),
              fromName: lctext.body.fromName,
              toName: lctext.body.toName,
              level: lctext.level,
              price: lctext.body.price,
              type: lctext.type,
              listtype: 1,
              vip: vip,
            }
          }


        }



      } else if (lctext.type == 15) { // 红包
        return {
          txt: '发了一个红包',
          name: lctext.name,
          level: lctext.level,
          type: lctext.type,
          color: '#ff265e',
          listtype: 2,
          vip: vip,
        }

      } else if (lctext.type == 4) { // 领红包
        return {
          txt: lctext.body,
          name: lctext.name,
          level: lctext.level,
          type: lctext.type,
          listtype: 2,
          vip: vip,
        }

      }
      else if (lctext.type == 9) {//直播结束
        // that.data.live_room.item.type=9
        // that.btn_liveDetail();
      } else if (lctext.type == 1) {// 发消息 
        return {
          txt: lctext.body,
          name: lctext.name,
          level: lctext.level,
          type: lctext.type,
          listtype: 2,
          vip: vip,
        }
      } else if (lctext.type == 41) {// 全站消息 
        return {
          txt: lctext.body,
          name: lctext.name,
          level: lctext.level,
          type: lctext.type,
          listtype: 2,
          vip: vip,
        }
      } else if (lctext.type == 35) { // 进入
        return {
          txt: lctext.body,
          name: lctext.name,
          level: lctext.level,
          type: lctext.type,
          listtype: 2,
          color: '#FFDB00',
          vip: vip,
        }
      }
      else if (lctext.type == 11 || lctext.type == 12) {  // 关注
        return {
          txt: lctext.body,
          name: lctext.name,
          level: lctext.level,
          type: lctext.type,
          listtype: 2,
          color: '#FFDB00',
          vip: vip,
        }
      } else if (lctext.type == 22 || lctext.type == 55 || lctext.type == 23) { // 系统通知

        return {
          txt: '·' + lctext.body,
          name: lctext.name,
          level: lctext.level,
          type: lctext.type,
          listtype: 3,
          color: '#FD8D8D',
          vip: vip,
        }
      }

      // else  if (lctext.body){  
      //   // console.log("namelength:" + lctext.name.length) 
      //   // console.log("bodylength:"+lctext.body.length)
      //   return {
      //     body: lctext.body,
      //     name: lctext.name,
      //     level: lctext.level,
      //     color:'#fff',
      //     namecolor:'#fff',
      //   }
      // }
      else {
        return
      }
    },


    scollami(ree) {
      console.log(ree)
      var xtset1 = setInterval(() => {
        if (this.$refs[ree].wrap.scrollTop + this.$refs[ree].wrap.clientHeight >= this.$refs[ree].wrap.scrollHeight) {
          this.$refs[ree].wrap.scrollTop = this.$refs[ree].wrap.scrollHeight;
          clearInterval(xtset1);
        } else {
          if (this.$refs[ree].wrap.scrollTop + this.$refs[ree].wrap.clientHeight < (this.$refs[ree].wrap.scrollHeight - 50)) {
            this.$refs[ree].wrap.scrollTop = this.$refs[ree].wrap.scrollHeight;
          } else {
            this.$refs[ree].wrap.scrollTop += 5
          }
        }
      }, 20);
    },
    changevip(vipP) {
      var vip = -1
      switch (vipP) {
        case -2:
          vip = 1
          break;
        case 1:
          vip = 2
          break;
        case 2:
          vip = 3
          break;
        case -3:
          vip = 4
          break;
        case -4:
          vip = 5
          break;
        default:
          vip = -1
      }
      return vip
    },
    //图片处理
    replace(str) {
      var i;
      if (str == null || str == '') {
        str = "https://img2.imbeiyu.com/head/defaultHead.png";
      }
      if (str.indexOf("http://sglive.imlianai.com") == 0) {
        i = str.replace("http://sglive.imlianai.com", "https://img2.imbeiyu.com")
      } else if (str.indexOf("http://lianai-image-head.imlianai.com") == 0) {
        i = str.replace("http://lianai-image-head.imlianai.com", "https://himg.nuannuanzhibo.com")

      } else if (str.indexOf("http://nn-img.nuannuanzhibo.com") == 0) {
        i = str.replace("http://nn-img.nuannuanzhibo.com", "https://img.imbeiyu.com")
      } else {
        i = str = "https://img2.imbeiyu.com/head/defaultHead.png";
      }
      return i
    }
  },
  filters: {
    replace(str) {
      var i;
      if (str == null || str == '') {
        i = str = "https://img2.imbeiyu.com/head/defaultHead.png";
      }
      if (str.indexOf("http://sglive.imlianai.com") == 0) {
        i = str.replace("http://sglive.imlianai.com", "https://img2.imbeiyu.com")
      } else if (str.indexOf("http://lianai-image-head.imlianai.com") == 0) {
        i = str.replace("http://lianai-image-head.imlianai.com", "https://himg.nuannuanzhibo.com")

      } else if (str.indexOf("http://nn-img.nuannuanzhibo.com") == 0) {
        i = str.replace("http://nn-img.nuannuanzhibo.com", "https://img.imbeiyu.com")
      } else {
        i = str = "https://img2.imbeiyu.com/head/defaultHead.png";
      }
      return i
    }
  },


}
</script>
<style lang="less" scoped>
button:active {
  opacity: .9;
}

.joinbox {
  width: 100%;
  height: 100%;
  background: url('https://resource.imbeiyu.com/gw/assets/PC/bg-1080.png');
  background-size: 100% 100%;
}

.getkbo {
  width: 4.64rem;
  height: 100%;
  margin: 0 auto;

  background: rgba(8, 36, 75, 0.8);
  border-radius: 6Px;
}

.getkbo {
  padding-top: .3rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.labe {
  width: .5rem;
}

.select {
  width: 2.6rem;
  display: flex;
  align-items: center;
  font-size: .1rem;
  color: #fff;
  margin-bottom: .2rem;

  .el-select {
    height: .28rem;
    width: 1.7rem;
  }

  .el-input__inner {
    border-radius: 2Px;
    font-size: .1rem;
    color: #fff;
    padding: 0 .1rem;
    box-sizing: border-box;
    background: rgba(8, 36, 75, 0);
    height: .28rem;
    line-height: .28rem;
    width: 100%;
    border: 1Px solid rgba(255, 255, 255, 0.4);
  }

  .queicon {
    background: url('https://resource.imbeiyu.com/20220218/img/studio_live_rule.png');
    background-size: 100% 100%;
    width: 0.15rem;
    height: 0.15rem;
    margin-left: .1rem;
    padding: 0;
  }

}

.starlive {
  margin-top: .25rem;
  width: 50%;
  height: .35rem;
  font-size: .12rem;
  background: linear-gradient(90deg, #4592fe 0%, #50ddfe 100%);
  ;
  color: #fff;
}

.kbfm {
  width: 2.6rem;
  display: flex;
  align-items: center;
  font-size: .1rem;
  color: #fff;
  margin-bottom: .15rem;

  img {
    width: .55rem;
    height: .55rem;
    border-radius: 5Px;
  }
}

.kbtxt {
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: .08rem;
  color: rgba(255, 255, 255, 0.5);
  margin-top: .1rem;

  a {
    color: rgba(141, 189, 255, 1);
  }
}

.kbtitle {
  width: 2.6rem;
  display: flex;
  align-items: center;
  font-size: .1rem;
  color: #fff;
  margin-bottom: .3rem;

  .input {
    position: relative;
    height: .28rem;
    width: 1.7rem;

    .changeBtn {
      background: url('https://resource.imbeiyu.com/gw/assets/PC/icon-random.png');
      background-size: 100% 100%;
      position: absolute;
      cursor: pointer;
      width: .28rem;
      height: .28rem;
      top: 0;
      right: 0;

    }
  }

  input {
    border-radius: 2Px;
    font-size: .1rem;
    color: #fff;
    padding: 0 .1rem;
    box-sizing: border-box;
    background: rgba(8, 36, 75, 0);
    height: .28rem;
    line-height: .28rem;
    width: 100%;
    border: 1Px solid rgba(255, 255, 255, 0.4);
  }

}

.btn {
  width: 2.6rem;

  .btntst {
    font-size: .06rem;
    color: rgba(255, 255, 255, 0.5);
    margin-top: .08rem;
    text-align: center;
    width: 2rem;
  }
}

.getdzbtn {
  width: 2rem;
  border-radius: 2Px;
  height: .3rem;
  line-height: .3rem;
  color: #fff;
  font-size: .1rem;
  margin-left: .1rem;
  background: linear-gradient(90deg, rgba(69, 146, 254, 1) 0%, rgba(80, 221, 254, 1) 100%);
}

.txtbox {
  margin-top: .3rem;
  padding: .12rem .16rem;
  box-sizing: border-box;
  width: 5rem;
  font-size: .08rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: .15rem;
  background: rgba(8, 36, 75, 0.8);
  border-radius: 4Px;

  .title {
    font-size: .11rem;
    margin-bottom: .08rem;
    color: rgba(255, 255, 255, 1);
  }

}

.videbox {
  height: 100%;
  background: rgba(8, 36, 75, 0.8);
  border-radius: 4Px;
  justify-content: center;
  display: flex;
  align-items: center;
}

.player {
  border-radius: 5Px;
  position: relative;

  .closebtn {
    background: rgba(255, 73, 73, 0.8);
    z-index: 99;
    border-radius: 5Px;
    position: absolute;
    right: .1rem;
    top: .1rem;
    width: .6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    height: .28rem;
    color: #fff;
    font-size: .09rem;

    i {
      background: url('https://resource.imbeiyu.com/gw/assets/PC/icon-exit-16.png');
      background-size: 100% 100%;
      width: .1rem;
      height: 0.1rem;
      margin-right: .03rem;
    }
  }

  .closebtn:active {
    transform: scale(.95);
  }
}

.kbbox {
  display: flex;
  justify-content: center;

  width: 100%;
  margin-top: .1rem;

  .right {
    width: 18%;
    height: 100%;
    margin-left: .05rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: rgba(8, 36, 75, 0.8);
    border-radius: 4Px;
    position: relative;
    padding-top: .25rem;
    box-sizing: border-box;

    .tabs {
      position: absolute;
      top: 0;
      left: 0;
    }

    .tsTxt {
      color: rgba(128, 255, 184, 1);
      background: rgba(0, 0, 0, 0.2);
      border-radius: 5Px;
      padding: .05rem;
      box-sizing: border-box;
    }

    .allinfo {
      width: 100%;
      height: 100%;
      position: relative;

      .songliinfoli {
        background: rgba(0, 0, 0, 0.2);
        border-radius: 5Px;
        padding: 5Px 8Px;
        box-sizing: border-box;
        ;
        color: rgba(255, 255, 255, 0.6);

        .name {
          color: rgba(255, 255, 255, 1);
        }

        .gift {
          color: rgba(253, 141, 141, 1);
        }

        .giftnum {
          color: #FFDB00;
        }

        span {
          height: .09rem;
          line-height: .09rem;
        }

        img {
          display: inline-block;
          width: auto;
          vertical-align: middle;
          height: .08rem;
        }

        .gifimg {
          height: .15rem;
        }
      }

      .xitonginfoli {
        border-radius: 15Px;
        padding: 5Px 8Px;
        box-sizing: border-box;
        color: #FFDB00;
        background: rgba(0, 0, 0, 0.2);
      }

      .ltinfoli {
        background: rgba(0, 0, 0, 0.2);
        max-width: 100%;
        width: auto;
        border-radius: 15Px;
        padding: 5Px 8Px;
        box-sizing: border-box;
        ;
        color: rgba(255, 255, 255, 1);

        span {
          height: .09rem;
          line-height: .09rem;
        }

        img {
          display: inline-block;
          height: .08rem;
          vertical-align: middle;
        }
      }


    }

    .xitonginfo {
      width: 100%;
      height: 100%;

      .li {
        color: #FFDB00;
        padding: 5Px 8Px;
        box-sizing: border-box;
        background: rgba(0, 0, 0, 0.2);
        border-radius: 15Px;
      }

    }

    .songliinfo {
      width: 100%;
      height: 100%;

      .li {
        background: rgba(0, 0, 0, 0.2);
        border-radius: 5Px;
        padding: 5Px 8Px;
        box-sizing: border-box;
        ;
        color: rgba(255, 255, 255, 0.6);

        .name {
          color: rgba(255, 255, 255, 1);
        }

        .gift {
          color: rgba(253, 141, 141, 1);
        }

        .giftnum {
          color: #FFDB00;
        }

        span {
          height: .09rem;
          line-height: .09rem;
        }

        img {
          display: inline-block;
          width: auto;
          vertical-align: middle;
          height: .08rem;
        }

        .gifimg {
          height: .15rem;
        }
      }
    }

    .ltinfo {
      width: 100%;
      height: 100%;
      position: relative;

      .li {
        background: rgba(0, 0, 0, 0.2);
        max-width: 100%;
        width: auto;
        border-radius: 15Px;
        padding: 5Px 8Px;
        box-sizing: border-box;
        ;
        color: rgba(255, 255, 255, 1);

        span {
          height: .09rem;
          line-height: .09rem;
        }

        img {
          display: inline-block;
          height: .08rem;
          vertical-align: middle;
        }
      }


    }

    .inputs {
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
      height: .25rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: rgba(255, 255, 255, 0.05);
      padding: 0 5Px;
      box-sizing: border-box;
      border-radius: 0px 0px 4Px 4Px;

      input {
        width: 85%;
        height: .18rem;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 2Px;
        padding: 0 5Px;
        box-sizing: border-box;
        font-size: .08rem;
        color: #fff;
      }

      input::-webkit-input-placeholder {
        /* WebKit browsers */
        color: rgba(255, 255, 255, .6);
      }

      button {
        width: 23%;
        border-radius: 2Px;
        height: .18rem;
        line-height: .18rem;
        color: #fff;
        font-size: .08rem;
        margin-left: .05rem;
        background: linear-gradient(90deg, rgba(69, 146, 254, 1) 0%, rgba(80, 221, 254, 1) 100%);
      }
    }

    ul {
      padding: .01rem .05rem;
      position: relative;
      height: 100%;
      box-sizing: border-box;

      .li {
        display: inline-block;
        font-size: .08rem;
        color: rgba(255, 255, 255, 0.7);
        line-height: .12rem;
        margin: .03rem 0;
      }
    }


  }

  .tabs {
    width: 100%;
    height: .2rem;
    cursor: pointer;
    border-bottom: 1Px solid rgba(255, 255, 255, 0.2);
    font-size: .018rem;
    padding: 0rem .05rem;
    box-sizing: border-box;
    color: rgba(255, 255, 255, 1);
    background: rgba(255, 255, 255, 0.05);
    display: flex;
    align-items: center;
    justify-content: space-between;

    p {
      text-align: center;
      width: 25%;
      height: .12rem;
      line-height: .12rem;
      border-right: 1Px solid rgba(255, 255, 255, 0.2);
      ;
      position: relative;
    }

    p:last-child {
      border-right: none
    }

    p.active {
      color: #6BE7FF;
    }

    .active::after {
      content: '';
      position: absolute;
      width: 30%;
      height: 2Px;
      bottom: -.04rem;
      left: 50%;
      transform: translateX(-50%);
      background: #6BE7FF;
    }

  }

  .left {
    width: 18%;
    height: 100%;
    margin-right: .05rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .userinfo {
      width: 100%;
      height: 14.7%;
      background: rgba(8, 36, 75, 0.8);
      border-radius: 4Px;
      display: flex;
      align-items: center;

      .head {
        margin-left: .15rem;
        width: .4rem;
        height: .4rem;
        border-radius: 50%;
      }

      .name {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        font-size: .09rem;
        text-overflow: ellipsis;
      }

      .imgss {
        display: flex;
        align-items: center;
        margin-top: .02rem;

        img {
          height: .1rem;
          width: auto;
          margin: 0 .01rem;
        }
      }

      .riinfo {
        margin-left: .08rem;
        display: flex;
        flex-direction: column;
        height: .4rem;
        justify-content: space-between;
        color: #fff;
        font-size: .1rem;
        justify-content: center;
        width: 50%;
      }

      .ID {
        margin-top: .02rem;
        color: rgba(255, 255, 255, 0.5);
        font-size: .08rem;
      }

    }

    .dooinfo {
      position: relative;
      width: 100%;
      height: 25%;
      background: rgba(8, 36, 75, 0.8);
      border-radius: 4Px;

      color: #fff;
      font-size: .08rem;

      .top {
        display: flex;
        margin-top: .06rem;
        padding: 0rem .05rem;
        box-sizing: border-box;

        input {
          border-radius: 2Px;
          font-size: .08rem;
          color: #fff;
          padding: 0 .05rem;
          box-sizing: border-box;
          background: rgba(8, 36, 75, 0);
          height: .2rem;
          line-height: .2rem;
          width: 73%;
          border: 1Px solid rgba(255, 255, 255, 0.4);
        }

        .fuzhi {
          width: 23%;
          border-radius: 2Px;
          height: .2rem;
          line-height: .2rem;
          color: #fff;
          font-size: .08rem;
          margin-left: .05rem;
          background: linear-gradient(90deg, rgba(69, 146, 254, 1) 0%, rgba(80, 221, 254, 1) 100%);
        }
      }

      .bomtxt {
        padding: 0rem .05rem;
        box-sizing: border-box;
        position: absolute;
        bottom: .09rem;

        font-size: .08rem;
        color: rgba(255, 255, 255, 0.8);
        line-height: .12rem;

        span {
          color: rgba(255, 219, 0, 1);
          cursor: pointer;
        }

        .title {
          font-size: .09rem;
          margin-bottom: .05rem;
          color: rgba(255, 255, 255, 1);
        }
      }
    }

    .listbox {
      position: relative;
      width: 100%;
      height: 84%;
      background: rgba(8, 36, 75, 0.8);
      border-radius: 4Px;
      color: #fff;
      font-size: .08rem;

      .gzlist {
        width: 100%;
        height: 100%;
      }

      .sylist {
        width: 100%;
        height: 100%;
      }

      .nums {
        text-align: center;
        line-height: .2rem;
        width: 100%;
        font-size: .09rem;
        color: rgba(255, 255, 255, 0.6);
      }

      ul {
        position: relative;
      }

      li {
        width: 100%;
        height: .4rem;
        display: flex;
        align-items: center;
        border-bottom: 1Px solid rgba(255, 255, 255, 0.2);

        .head {
          margin-left: .05rem;
          width: .26rem;
          height: .26rem;
          border-radius: 50%;
        }

        .name {
          width: 70%;
          white-space: nowrap;
          overflow: hidden;
          font-size: .09rem;
          text-overflow: ellipsis;
        }

        .imgss {
          display: flex;
          align-items: center;
          margin-top: .05rem;

          img {
            height: .08rem;
            width: auto;
            margin: 0 .01rem;
          }
        }

        .riinfo {
          width: 60%;
          margin-left: .05rem;
          display: flex;
          flex-direction: column;
          height: .4rem;
          justify-content: space-between;
          color: #fff;
          font-size: .1rem;
          justify-content: center;
        }

        .ID {
          margin-top: .05rem;
          color: rgba(255, 255, 255, 0.5);
          font-size: .08rem;
        }

      }

      .gzlist {
        li {
          .head {
            margin-left: .1rem;
          }

          .riinfo {
            margin-left: .1rem;
          }
        }
      }

      .sylist {
        .rank {
          width: .15rem;
          text-align: center;
          font-size: .1rem;
          font-weight: 600;
        }

        li {
          padding: 0 .05rem;
          box-sizing: border-box;

          .riinfo {
            width: 40%;
          }

          .gxnum {
            width: 40%;
            color: rgba(255, 255, 255, 0.6);
            text-align: right;

            .ybnum {
              color: rgba(255, 213, 46, 1);
            }
          }
        }
      }
    }
  }

}

.title_t {
  width: 100%;
  height: .15rem;
  line-height: .15rem;
  border-bottom: 1Px solid rgba(255, 255, 255, 0.2);
  font-size: .018rem;
  padding: 0rem .05rem;
  box-sizing: border-box;
  color: rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.05);
}

.el-scrollbar {
  position: relative;
}

.nodata {
  position: absolute;
  width: .78rem;
  height: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.live-center {
  position: relative;
  height: 100%;
}

.giftmp4 {
  width: 100%;
  overflow: hidden;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.giftwebp {
  width: 100%;
  overflow: hidden;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.giftwebp {
  img {
    height: 100%;
    display: block;
    margin: 0 auto;
    width: auto;
  }
}

.giftsvga {
  width: 100%;
  overflow: hidden;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;

  .container {
    width: 100%;
    height: 600px;
    position: absolute;
    top: -55%;
    left: 0;
  }
}

.svga {
  // position: absolute;
  //  height: 100%;
  // top: 50%;
  // transform: rotate(90deg)  ;
  // margin: 100px auto;
}

.top3box {

  width: 100%;
  height: .83rem;

  .headbox {

    width: 100%;
    margin: 0 auto;
    position: relative;

    .topbg {
      position: absolute;
      width: 30%;
      display: flex;
      align-items: center;
      flex-direction: column;

      .headbox {
        width: .4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        height: .4rem;
        position: relative;
      }

      .head {
        position: relative;
        border-radius: 50%;
        width: .28rem;
        height: .28rem;
      }
    }

    .top1bg {
      top: .0rem;
      left: 50%;
      transform: translateX(-50%);

      .headbg {
        background: url('https://resource.imbeiyu.com/gw/assets/images/PC/rank_head_1_120.png');
        background-size: 100% 100%;
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
      }
    }

    .top2bg {

      top: .1rem;
      left: 0rem;

      .headbg {
        background: url('https://resource.imbeiyu.com/gw/assets/images/PC/rank_head_2_100.png');
        background-size: 100% 100%;
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
      }
    }

    .top3bg {

      top: .13rem;
      right: 0rem;

      .headbg {
        background: url('https://resource.imbeiyu.com/gw/assets/images/PC/rank_head_3_100.png');
        background-size: 100% 100%;
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
      }
    }
  }

  .topuser {
    display: flex;
    flex-direction: column;
    width: 100%;
    font-size: .028rem;
    color: rgba(255, 255, 255, 1);

    .num {
      margin-top: 0.02rem;
      color: rgba(255, 255, 255, .5);
      width: 100%;
      font-size: .028rem;
      display: flex;
      align-items: center;
      justify-content: center;

      .ybnum {
        color: rgba(255, 213, 46, 1);
      }
    }

    .imgs {
      display: flex;
      margin-top: 0.02rem;
      align-items: center;
      justify-content: center;

      img {
        height: .08rem;
      }
    }

    .name {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-align: center;
      text-overflow: ellipsis;
    }
  }

}

.player {
  width: 533px;
  height: 300px;
}
</style>


// WEBPACK FOOTER //
// src/page/webpage/nnlive.vue